export function cookie(
  method = 'set',
  cname = '',
  cvalue = '',
  cdomain = '',
  isSecure = true,
  isHttpOnly = false,
  expireInDays = 365,
) {
  // eslint-disable-line consistent-return
  function getCookie(name) {
    const lcookie = document.cookie.split(';').find((llcookie) => llcookie.trim().startsWith(`${name}=`));
    if (lcookie) {
      return document.cookie
        .split(';')
        .map((c) => c.split('='))
        .reduce(
          (acc, [key, val]) => ({
            ...acc,
            [key.trim()]: decodeURIComponent(val),
          }),
          {},
        )[name];
    }
    return false;
  }

  function setCookie(n, v, d, s = true, h = false, e = 365) {
    const expirationDate = new Date(Date.now() + e * 864e5).toUTCString();

    document.cookie = `${n}= ${v || ''}; Path=/; Domain=${d || ''}${s ? '; Secure' : ''}${h ? '; HttpOnly' : ''}; Expires=${expirationDate}`;
  }

  function deleteCookie(n) {
    document.cookie = `${n}=; expires=Thu, 01 Jan 1970 00:00:00 UTC`;
  }

  if (method === 'set' && cname.length > 0) {
    setCookie(cname, cvalue, cdomain, isSecure, isHttpOnly, expireInDays);
  } else if (method === 'get') {
    return getCookie(cname);
  } else if (method === 'delete' && getCookie(cname)) {
    deleteCookie(cname);
  }
}
